// extracted by mini-css-extract-plugin
export var backdropBlur = "_mr-0";
export var contentCard = "_mr-5";
export var frame = "_mr-2";
export var image = "_mr-4";
export var imagePane = "_mr-3";
export var modal = "_mr-1";